import { getContext } from '@/context';
import { MINIAPP_PACKAGE_ID } from '@/consts/configs';
import ANALYTICS_EVENT_NAMES from '@/consts/analytics';
import type {
  AnalyticsSettings,
  AnalyticsSettingsWithError,
} from '@/types/analytics';

// Discriminated union for function options
type SendAiGenItemLoadOptions =
  | {
      result: 'success';
      processing_time: number;
      settings: AnalyticsSettings;
    }
  | {
      result: 'failure';
      processing_time: number;
      settings: AnalyticsSettingsWithError;
    };

/**
 * Sends an ai_gen_item_load analytics event.
 * Tracks generation success/failure with timing metrics.
 */
export const sendAiGenItemLoadAnalytics = (
  options: SendAiGenItemLoadOptions
) => {
  try {
    const params = {
      package_id: MINIAPP_PACKAGE_ID,
      result: options.result,
      processing_time: options.processing_time,
      settings: options.settings,
    };

    getContext().handlers.sendAnalytics({
      eventName: ANALYTICS_EVENT_NAMES.AI_GEN_ITEM_LOAD,
      params,
    });
  } catch {
    // Failed to send analytics
  }
};
